module.exports = __webpack_public_path__ + "npay.png?c3e304a17aca0ddc222aca10b0e9b8f0";


//////////////////
// WEBPACK FOOTER
// ./images/pricing/npay.png
// module id = 10
// module chunks = 0